import api from "./api";

export interface BusinessInfo {
  address?: string;
  // Fleet specific
  business_type?: string;
  company_name?: string;
  // Courier specific
  coverage_area?: string;
  // Restaurant specific
  cuisine_type?: any;
  deliveryMethods?: any;
  description?: string;
  email?: string;
  fleet_size?: string;
  id: string;
  operating_area?: string;
  operating_hours: {};
  operatingHours?: any;
  packageTypes?: any;
  phone?: string;
  role: "CourierOwner" | "FleetOwner" | "RestaurantOwner";
  services?: any;
  serviceType?: string;
  vehicle_types?: any;
  website?: string;
}

class BusinessInfoService {
  async createBusinessInfo(data: BusinessInfo): Promise<BusinessInfo> {
    const response = await api.post("/business/info", data);
    return response.data.business;
  }

  async getBusinessInfo(): Promise<BusinessInfo> {
    const response = await api.get("/business/info");
    return response.data.business;
  }

  async updateBusinessInfo(data: Partial<BusinessInfo>): Promise<BusinessInfo> {
    const response = await api.put("/business/info", data);
    return response.data.business;
  }
}

export default new BusinessInfoService();
